import { BaseTable } from "components"
import { useFormContext, useWatch } from "react-hook-form"
import { FormReturnItemsType } from "../types"
import { calculateSummaryReturnItems } from "../utils/functions/calculateSummaryReturnItems"
import { convertNumber } from "utils"

export const SummaryFooter = () => {
  const { control } = useFormContext<FormReturnItemsType>()
  const return_detail = useWatch({
    control,
    name: 'return_detail'
  })
  const summary = calculateSummaryReturnItems(return_detail ?? [])

  return (
    <BaseTable plain className="w-full min-w-[100px] md:max-w-[400px]">
      <tbody>
        <tr>
          <td className="w-[1px] whitespace-nowrap">SUBTOTAL</td>
          <td>{convertNumber(summary.subtotal).intoCurrency}</td>
        </tr>
        <tr>
          <td className="w-[1px] whitespace-nowrap">TAX</td>
          <td>{convertNumber(summary.tax).intoCurrency}</td>
        </tr>
        <tr className="font-bold">
          <td className="w-[1px] whitespace-nowrap">TOTAL RETURN</td>
          <td>{convertNumber(summary.totalReject).intoCurrency}</td>
        </tr>
        <tr className="border-y-2 border-black text-lg font-bold">
          <td className="w-[1px] whitespace-nowrap">BALANCE</td>
          <td>{convertNumber(summary.totalReject).intoCurrency}</td>
        </tr>
      </tbody>
    </BaseTable>
  )
}
